import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { localNews, nearbyEvents, usefulServices } from '../../data/espace';
function SectionHeading({
  title,
  hint
}: {
  title: string;
  hint?: string;
}) {
  return <div data-id="element-1047" data-mp="1g1v46vjm5d72">
      <button type="button" className="group inline-flex items-center gap-2 rounded text-2xl font-extrabold tracking-tight text-ville-navy transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1048" data-mp="1g1lb2z39upx5">
        {title}
        <ChevronRightIcon className="h-6 w-6 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1049" data-mp="1yu5rvi5p54kl" />
      </button>
      {hint && <p className="mt-1 text-[15px] text-slate-500" data-id="element-1050" data-mp="ngtu9p0j5i6v">{hint}</p>}
    </div>;
}
export function LocalNews() {
  return <section aria-labelledby="local-news-title" className="mt-12" data-id="element-1051" data-mp="jfrrwzbbgq0o">
      <h2 id="local-news-title" className="sr-only" data-id="element-1052" data-mp="1qnyr2ey0tqs">
        My local news
      </h2>
      <SectionHeading title="My local news" data-id="element-1053" data-mp="6opebdd5uaxi" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1054" data-mp="6mczva6m2ip7">
        {localNews.map(item => <li key={item.id} className="flex" data-id="element-1055" data-mp="3owevnb0ypqmh">
            <Link to={item.to ?? '/my-dashboard'} className="group flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1056" data-mp="3sumf4dmt961d">
              <img src={item.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1057" data-mp="357o25pxwgg87" />
              <span className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1058" data-mp="3a5pii33xy1fz">
                <span className="text-sm text-slate-500" data-id="element-1059" data-mp="2w54zp6y105mh">{item.date}</span>
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-ville-indigo" data-id="element-1060" data-mp="314hvih6vkn17">
                  {item.category}
                </span>
                <span className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1061" data-mp="16pu9p17ux8sm">{item.title}</span>
                <span className="mt-auto pt-3 text-right text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-1062" data-mp="11w88c5758rc4">
                  Read more
                </span>
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}
export function NearbyEvents() {
  return <section aria-labelledby="nearby-events-title" className="mt-12" data-id="element-1063" data-mp="1knsno5i9n37l">
      <h2 id="nearby-events-title" className="sr-only" data-id="element-1064" data-mp="1gmfhfub9gy05">
        Events near me
      </h2>
      <SectionHeading title="Events near me" data-id="element-1065" data-mp="1goa2r9qg2s4r" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1066" data-mp="1bmayzyqslt7a">
        {nearbyEvents.map(event => <li key={event.id} className="flex" data-id="element-1067" data-mp="581v4tw5oqm8">
            <article className="flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1068" data-mp="875eto4a72r">
              <img src={event.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1069" data-mp="2bvssvqhb4oe3" />
              <div className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1070" data-mp="2gund8wuxal0b">
                <p className="text-sm font-semibold text-ville-indigo" data-id="element-1071" data-mp="2guvmmeru786r">{event.date}</p>
                {event.time && <p className="text-sm text-slate-500" data-id="element-1072" data-mp="2kuxoanxko1m1">{event.time}</p>}
                <h3 className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1073" data-mp="2pnqw5koc7q2c">{event.title}</h3>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}
export function UsefulServices() {
  return <section aria-labelledby="useful-services-title" className="mt-12" data-id="element-1074" data-mp="2zmy9w8yzhmpz">
      <h2 id="useful-services-title" className="sr-only" data-id="element-1075" data-mp="34kzqmn8xt9ya">
        My useful services
      </h2>
      <SectionHeading title="My useful services" hint="Hours and basic information" data-id="element-1076" data-mp="38l9yy6k7ccgb" />

      <ul className="-mx-5 mt-5 flex snap-x gap-4 overflow-x-auto px-5 pb-2 lg:-mx-10 lg:px-10" data-id="element-1077" data-mp="1a7ia3k6y9dcr">
        {usefulServices.map(service => <li key={service.id} className="w-[210px] shrink-0 snap-start" data-id="element-1078" data-mp="ixlwenddjzn3">
            <article className="h-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1079" data-mp="ivsq596obhfm">
              <img src={service.image} alt="" className="h-32 w-full object-cover" data-id="element-1080" data-mp="ey3bvspgtqks" />
              <div className="p-4 text-center" data-id="element-1081" data-mp="sv9u9m6a1n9h">
                <h3 className="text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1082" data-mp="nwykfbfzfcr9">{service.name}</h3>
                <p className={`mt-2 text-sm font-bold ${service.open ? 'text-ville-indigo' : 'text-slate-500'}`} data-id="element-1083" data-mp="6uolq91chat">
                  {service.open ? 'Open' : 'Closed'}
                </p>
                <p className="text-xs text-slate-500" data-id="element-1084" data-mp="9xz54ued0a7r">{service.hours}</p>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}